import DashboardSummary from './components/dashboard/dashboardsummary';
import KMReport from './components/reportings/kmreport';
import GroupTracking from './components/grouptracking/grouptracking';

var routes = 
  [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: "ni ni-tv-2 text-primary",
      component: DashboardSummary,
    },
    {
      path: "/group-tracking",
      name: "Group Tracking",
      icon: "ni ni-tv-2 text-primary",
      component: GroupTracking,
     },
    {
      path: "/kmreport",
      name: "KM Report",
      icon: "ni ni-tv-2 text-primary",
      component: KMReport,
    },
  ];
  
export default routes;
